"use client";

import Script from "next/script";
import { useEffect, useRef, useState } from "react";
type GoogleIdentity = {
  initialize: (options: {
    client_id: string;
    callback: (response: {
      credential: string;
    }) => void;
    auto_select: boolean;
  }) => void;
  renderButton: (element: HTMLElement, options: {
    type: "standard";
    theme: "outline" | "filled_black";
    size: "large";
    text: "continue_with";
    shape: "rectangular";
    width: number;
  }) => void;
};
let initialized = false;
let receiveCredential: ((token: string) => void) | undefined;
export function GoogleButton({
  onCredential
}: {
  onCredential: (token: string) => void;
}) {
  const target = useRef<HTMLDivElement>(null);
  const callback = useRef(onCredential);
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);
  const clientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;
  callback.current = onCredential;
  useEffect(() => {
    if (!clientId || !ready || !target.current) return;
    const google = (window as Window & {
      google?: {
        accounts: {
          id: GoogleIdentity;
        };
      };
    }).google;
    if (!google) {
      setFailed(true);
      return;
    }
    const receive = (token: string) => callback.current(token);
    receiveCredential = receive;
    if (!initialized) {
      google.accounts.id.initialize({
        client_id: clientId,
        auto_select: false,
        callback: response => receiveCredential?.(response.credential)
      });
      initialized = true;
    }
    google.accounts.id.renderButton(target.current, {
      type: "standard",
      theme: document.documentElement.classList.contains("dark") ? "filled_black" : "outline",
      size: "large",
      text: "continue_with",
      shape: "rectangular",
      width: Math.min(400, target.current.clientWidth)
    });
    return () => {
      if (receiveCredential === receive) receiveCredential = undefined;
    };
  }, [clientId, ready]);
  if (!clientId) return null;
  return <><Script src="https://accounts.google.com/gsi/client" onReady={() => setReady(true)} onError={() => setFailed(true)} /><div className="atlas-google-button" ref={target} />{failed ? <p className="atlas-form-note" role="status">Google sign-in is unavailable.</p> : !ready && <p className="atlas-form-note" role="status">Loading Google sign-in…</p>}<div className="atlas-form-divider"><span>or</span></div></>;
}